export const SUBSCRIPTION_REQUEST_QUERY_KEYS = {
  all: ["subscription-request"] as const,
  activePromotions: (organizationId: string) => [
    ...SUBSCRIPTION_REQUEST_QUERY_KEYS.all,
    "active-promotions",
    organizationId,
  ] as const,
  upsellOffer: (organizationId: string) => [
    ...SUBSCRIPTION_REQUEST_QUERY_KEYS.all,
    "upsell-offer",
    organizationId,
  ] as const,
} as const;
